<template>

    <div class="preloader" v-if="loading">
      <div class="preloader-content"></div>
    </div>

    <router-view v-else></router-view>
</template>

<script>
import EventBus from './AppEventBus';
import LoginMixin from './mixins/Login';

export default {
    themeChangeListener: null,
    mixins : [LoginMixin],
    data() {
        return {
            user : null,
            permissoes: [],
            loading : false
        }
    },
    created() {
        
    },
    mounted() {
        this.themeChangeListener = (event) => {
            const elementId = 'theme-link';
            const linkElement = document.getElementById(elementId);
            const cloneLinkElement = linkElement.cloneNode(true);
            const newThemeUrl = linkElement.getAttribute('href').replace(this.$appState.theme, event.theme);

            cloneLinkElement.setAttribute('id', elementId + '-clone');
            cloneLinkElement.setAttribute('href', newThemeUrl);
            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', elementId);
            });
            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
        
            this.$appState.theme = event.theme;
            this.$appState.darkTheme = event.dark;
        };

        EventBus.on('theme-change', this.themeChangeListener);
    },
    beforeUnmount() {
        EventBus.off('theme-change', this.themeChangeListener);
    },
    methods : {
        getPermissoes() {
            console.log("getPermissoes");
            console.log(this.$root.permissoes);
        }
    },
}
</script>